import { useParams } from 'react-router-dom';
import { IBooking } from '../../utils/entities/interface';
import { useState } from 'react';
import { ViewBooking } from '../Booking/actions/Viewbooking';

export const UserHistory = () => {
  const { bookingId } = useParams<{ bookingId: string }>();
  const [booking, setBooking] = useState<IBooking | null>(null);

  return (
    <>
      <ViewBooking type="CUSTOMERHISTORY" />
    </>
  );
};
